export default {
  listMake: [],
  listYears: [],
  listMakeYears: [],
  listCars: [],
  listSubCars: [],
  listEngine: [],
  listCarData: [],
  listComment: [],
  listReviews: [],
  ListParticipants: [],
  ListMostLike: [],
  ListCarPrice: [],
  ListCarCategory: [],
  ListCarsCategory: [],
  ListLike: [],
  ListCarLike: [],
  ListCarsRate: [],
  objCarData: {},
};
